module.exports = __webpack_public_path__ + "img/about-04-partner.b357a730.png";